import classNames from 'clsx';
import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../ctx/OpenExternalLinkCtx';

export const TagHeadingFactory = (
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  inDocView: boolean,
) => {
  const Heading = (props: React.HTMLAttributes<HTMLHeadingElement>) => {
    const slugIdPrefix = useContextSelector(
      MarkdownOpenExternalLinkCtx,
      (state) => state.slugIdPrefix,
    );
    const activeId = props.id ? slugIdPrefix + props.id : undefined;
    const enableHeadingAutoLink = useContextSelector(
      MarkdownOpenExternalLinkCtx,
      (state) => state.enableHeadingAutoLink,
    );
    const autoLink = enableHeadingAutoLink ? (
      <a className="anchor" aria-hidden="true" tabIndex={-1} href={'#' + activeId}>
        <span className="icon-link">#</span>
      </a>
    ) : null;

    return React.createElement(
      tag,
      {
        ...props,
        className: classNames(props.className, inDocView ? 'markdown-doc-viewer-heading' : null),
        id: activeId,
      },
      <>
        {props.children}
        {autoLink}
      </>,
    );
  };
  return Heading;
};
